module.exports = __webpack_public_path__ + "static/SoinSansNeue-Bold-e83f822545c8519666c3351a1ea1068c.otf";